export const onlyNumbers = "^[0-9]*$";
export const onlyNumbersNonNull = "^[1-9][0-9]*$";
export const percentageNegativeAndPositive = "^[\-]?([0-9]{0,2}?)(\,[0-9]{0,2})?$";
export const percentageWith3Digits = "^[\-]?([0-9]{0,3}?)(\,[0-9]{0,3})?$";
export const currencyPositive = "^[0-9]+,?[0-9]{0,2}?$";
export const currencyPositiveWith4Digits = "^[0-9]+,?[0-9]{0,4}?$";